import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { ChevronDown, Check } from "lucide-react";

import StockOptionsMultiplier from "./StocksOptionsMultiplier/StockOptionsMultiplier";
import IndexptionsMultiplier from "./IndexOptionsMultiplier/IndexOptionsMultiplier";
import NiftyVixConfig from "./NiftyVixConfig/NiftyVixConfig";
import BankNiftyVixConfig from "./BankNiftyVixConfig/BankNiftyVixConfig";
// import BankNiftyRegimeConfig from "./BankNiftyRegimeConfig/BankNiftyRegimeConfig";
import NiftyRegimeConfig from "./NiftyRegimeConfig/NiftyRegimeConfig";
import DynamicRegimeConfig from "./DynamicRegimeConfig/DynamicRegimeConfig";
import AdditionalStockUnderlyings from "./AdditionalStocksUnderlying/AdditionalStockUnderlyings";
import VMAData from "./VMA/vmaData";
import FyersUserList from "./FyersUsersList/fyersUser";
import RegimeData from "./RegimeData/regimeData";
import OptimusToggleData from "./OptimusToggles/optimusData";
import SignalUpdateData from "./SignalUpdateData/SignalUpdateData";
import SymbolUpdateData from "./SymbolUpdateData/SymbolUpdateData";

export default function BotConfig() {
  const cachedAccess = localStorage.getItem("user_access");
  const userAccess = cachedAccess ? JSON.parse(cachedAccess) : null;
  const isSymbolUpdateAllowed = userAccess?.is_symbol_update === true;

  const [activeTab, setActiveTab] = useState("fyers-users-list");
  const [regimeTables, setRegimeTables] = useState([
    {
      table_name: "nifty_regime_grid",
      display_name: "Nifty Regime",
      key: "nifty-regime-grid",
    },
  ]);

  const currentRegime = regimeTables.find(
    (tbl) => (tbl.key || tbl.table_name) === activeTab
  );
  const isRegimeActive = Boolean(currentRegime);

  useEffect(() => {
    apiClient
      .get(`${server.godseye.baseUrl}get-regime-grid-tables`)
      .then((response) => {
        if (response.data && response.data.tables && response.data.tables.length > 0) {
          setRegimeTables(response.data.tables);
        }
      })
      .catch((error) => {
        console.error("Error fetching regime tables:", error);
      });
  }, []);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full min-h-screen font-urbanist">
        <main className="flex flex-1 overflow-hidden flex-col w-full h-full  transition-all duration-300 ease-in-out ">
          <div>
            <div className="flex w-full h-full ">
              <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full min-w-0">
                <div className="flex px-6 py-2 w-full overflow-x-auto custom-scroll">
                  <TabsList className="inline-flex space-x-[6px] shrink-0 justify-start items-center">
                    <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="fyers-users-list"
                    >
                      Fyers Users
                    </TabsTrigger>
                    <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="stocks-muliplier"
                    >
                      Stocks Multiplier
                    </TabsTrigger>
                    <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="index-muliplier"
                    >
                      Index Multiplier
                    </TabsTrigger>
                    {/* <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="nifty-lot-config"
                    >
                      NF_VIX Lot Config
                    </TabsTrigger> */}
                    {/* <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="banknifty-lot-config"
                    >
                      BNF_VIX Lot Config
                    </TabsTrigger> */}

                    <TabsTrigger
                      className="text-[15px] shrink-0"
                      value="additional-stocks"
                    >
                      Additonal Stocks Underlying
                    </TabsTrigger>
                    {/* <TabsTrigger className="text-[15px] shrink-0" value="vma-table">
                      VMA Table
                    </TabsTrigger> */}
                     <TabsTrigger className="text-[15px] shrink-0" value="regime-table">
                      Regime Table
                    </TabsTrigger>
                     <TabsTrigger className="text-[15px] shrink-0" value="signal-update">
                      Signal Update
                    </TabsTrigger>
                      {isSymbolUpdateAllowed && (
                        <TabsTrigger className="text-[15px] shrink-0" value="symbol-update">
                          Symbol Update
                        </TabsTrigger>
                      )}

                      {regimeTables.length > 0 && (
                        <DropdownMenu>
                          <DropdownMenuTrigger
                            className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-[15px] font-medium transition-all outline-none gap-1.5 shrink-0 h-[32px] cursor-pointer ${
                              isRegimeActive
                                ? "bg-background text-foreground shadow font-semibold"
                                : "text-muted-foreground hover:text-foreground hover:bg-background/50"
                            }`}
                          >
                            <span>
                              {isRegimeActive
                                ? currentRegime?.display_name
                                : "Regime Grids"}
                            </span>
                            <ChevronDown className="h-4 w-4 opacity-70" />
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="start" className="z-[9999] min-w-[200px] max-h-72 overflow-y-auto custom-scroll">
                            <DropdownMenuLabel className="text-xs text-muted-foreground uppercase tracking-wider px-2 py-1.5">
                              Regime Grids
                            </DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            {regimeTables.map((tbl) => {
                              const val = tbl.key || tbl.table_name;
                              const isSelected = activeTab === val;
                              return (
                                <DropdownMenuItem
                                  key={val}
                                  onClick={() => setActiveTab(val)}
                                  className={`cursor-pointer text-sm flex items-center justify-between px-3 py-2 ${
                                    isSelected
                                      ? "bg-accent font-semibold text-accent-foreground"
                                      : "hover:bg-accent/50"
                                  }`}
                                >
                                  <span>{tbl.display_name}</span>
                                  {isSelected && <Check className="h-4 w-4 text-emerald-500 ml-2" />}
                                </DropdownMenuItem>
                              );
                            })}
                          </DropdownMenuContent>
                        </DropdownMenu>
                      )}

                    <TabsTrigger className="text-[15px] shrink-0" value="optimus-toggle">
                      Optimus Toggles
                    </TabsTrigger>
                  </TabsList>
                </div>
                <TabsContent
                  value="fyers-users-list"
                  className="mt-[20px] w-full rounded-md "
                >
                  <FyersUserList />
                </TabsContent>
                <TabsContent
                  value="stocks-muliplier"
                  className="mt-[20px] w-full rounded-md "
                >
                  <StockOptionsMultiplier />
                </TabsContent>
                <TabsContent
                  value="index-muliplier"
                  className="mt-[20px] w-full rounded-md "
                >
                  <IndexptionsMultiplier />
                </TabsContent>
                {/* <TabsContent
                  value="nifty-lot-config"
                  className="mt-[20px] w-full rounded-md "
                >
                  <NiftyVixConfig />
                </TabsContent> */}
                {/* <TabsContent
                  value="banknifty-lot-config"
                  className="mt-[20px] w-full rounded-md "
                >
                  <BankNiftyVixConfig />
                </TabsContent> */}
                <TabsContent
                  value="additional-stocks"
                  className="mt-[20px] w-full rounded-md "
                >
                  <AdditionalStockUnderlyings />
                </TabsContent>
                {/* <TabsContent
                  value="vma-table"
                  className="mt-[20px] w-full rounded-md "
                >
                  <VMAData />
                </TabsContent> */}
                 <TabsContent
                  value="regime-table"
                  className="mt-[20px] w-full rounded-md "
                >
                  <RegimeData />
                </TabsContent>

                 <TabsContent
                  value="signal-update"
                  className="mt-[20px] w-full rounded-md "
                >
                  <SignalUpdateData />
                </TabsContent>

                 {isSymbolUpdateAllowed && (
                   <TabsContent
                    value="symbol-update"
                    className="mt-[20px] w-full rounded-md "
                  >
                    <SymbolUpdateData />
                  </TabsContent>
                 )}

                {regimeTables.map((tbl) => (
                  <TabsContent
                    key={tbl.key || tbl.table_name}
                    value={tbl.key || tbl.table_name}
                    className="mt-[20px] w-full rounded-md"
                  >
                    <DynamicRegimeConfig
                      tableName={tbl.table_name}
                      displayName={tbl.display_name}
                    />
                  </TabsContent>
                ))}

                 <TabsContent
                  value="optimus-toggle"
                  className="mt-[20px] w-full rounded-md "
                >
                  <OptimusToggleData />
                </TabsContent>

              </Tabs>
            </div>
          </div>
        </main>
      </div>
    </DashboardLayout>
  );
}
